/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetConnectionSettingsQueryResponse, SocialExportGetConnectionSettingsPathParams, SocialExportGetConnectionSettings400, SocialExportGetConnectionSettings401, SocialExportGetConnectionSettings403 } from "../models/SocialExportGetConnectionSettings";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { socialExportGetConnectionSettings } from "../axios/socialExportGetConnectionSettings";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const socialExportGetConnectionSettingsQueryKey = (id: SocialExportGetConnectionSettingsPathParams["id"]) => ["api-v2", { url: '/social-export/v1/connections/:id/settings', params: {id:id} }] as const

export type SocialExportGetConnectionSettingsQueryKey = ReturnType<typeof socialExportGetConnectionSettingsQueryKey>

export function socialExportGetConnectionSettingsQueryOptions(id: SocialExportGetConnectionSettingsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = socialExportGetConnectionSettingsQueryKey(id)
        return queryOptions<SocialExportGetConnectionSettingsQueryResponse, ResponseErrorConfig<SocialExportGetConnectionSettings400 | SocialExportGetConnectionSettings401 | SocialExportGetConnectionSettings403>, SocialExportGetConnectionSettingsQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return socialExportGetConnectionSettings(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns platform-specific settings for the connection, merged with platform defaults.
 * @summary Get connection settings by connection id
 * {@link /social-export/v1/connections/:id/settings}
 */
export function useSocialExportGetConnectionSettings<TData = SocialExportGetConnectionSettingsQueryResponse, TQueryData = SocialExportGetConnectionSettingsQueryResponse, TQueryKey extends QueryKey = SocialExportGetConnectionSettingsQueryKey>(id: SocialExportGetConnectionSettingsPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<SocialExportGetConnectionSettingsQueryResponse, ResponseErrorConfig<SocialExportGetConnectionSettings400 | SocialExportGetConnectionSettings401 | SocialExportGetConnectionSettings403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? socialExportGetConnectionSettingsQueryKey(id)
         

         const query = useQuery({
          ...socialExportGetConnectionSettingsQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SocialExportGetConnectionSettings400 | SocialExportGetConnectionSettings401 | SocialExportGetConnectionSettings403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}